import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CustomPage from './pages/CustomPage';
import AboutPage from './pages/AboutPage';
import DirectoryPage from './pages/DirectoryPage';
import InterpreterProfilePage from './pages/InterpreterProfilePage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import MembershipPage from './pages/MembershipPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import EventsPage from './pages/EventsPage';
import ResourcesPage from './pages/ResourcesPage';
import FlashPage from './pages/FlashPage';
import PeriodicalsPage from './pages/PeriodicalsPage';
import ConsejoDirectivoPage from './pages/ConsejoDirectivoPage';
import ExpresidentesPage from './pages/ExpresidentesPage';
import FotosExpresidentesPage from './pages/FotosExpresidentesPage';
import GalleryPage from './pages/GalleryPage';
import RegulationPage from './pages/RegulationPage';
import StatutesPage from './pages/StatutesPage';
import PrivacyPage from './pages/PrivacyPage';
import InterpreterDashboard from './pages/InterpreterDashboard';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import MenuVisibilityPage from './pages/admin/MenuVisibilityPage'; // legacy, kept for now
import AdminMenusPage from './pages/admin/AdminMenusPage';
import AdminInterpretersPage from './pages/admin/AdminInterpretersPage';
import AdminNewsPage from './pages/admin/AdminNewsPage';
import AdminEventsPage from './pages/admin/AdminEventsPage';
import AdminForumPage from './pages/admin/AdminForumPage';
import AdminPeriodicalsPage from './pages/admin/AdminPeriodicalsPage';
import AdminTranslationsPage from './pages/admin/AdminTranslationsPage';
import AdminDuesPage from './pages/admin/AdminDuesPage';
import AdminProfileEditsPage from './pages/admin/AdminProfileEditsPage';
import AdminContactPage from './pages/admin/AdminContactPage';
import AdminContactEditorPage from './pages/admin/AdminContactEditorPage';
import AdminBoardPage from './pages/admin/AdminBoardPage';
import AdminPastPresidentsPage from './pages/admin/AdminPastPresidentsPage';
import AdminPhotoGalleriesPage from './pages/admin/AdminPhotoGalleriesPage';
import AdminHomeLayoutPage from './pages/admin/AdminHomeLayoutPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import AdminNewsletterPage from './pages/admin/AdminNewsletterPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminRolesPage from './pages/admin/AdminRolesPage';
import AdminTrashPage from './pages/admin/AdminTrashPage';
import AdminInterpretersBulkPage from './pages/admin/AdminInterpretersBulkPage';
import AdminCatalogsPage from './pages/admin/AdminCatalogsPage';
import InvitationAcceptPage from './pages/InvitationAcceptPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SecurityRecoverPage from './pages/SecurityRecoverPage';
import ProfileSecurityPage from './pages/ProfileSecurityPage';
import RegisterConfirmPage from './pages/RegisterConfirmPage';
import SupportThreadPage from './pages/SupportThreadPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AdminMemberRegistrationsPage from './pages/admin/AdminMemberRegistrationsPage';
import AdminPagesPage from './pages/admin/AdminPagesPage';
import AdminPageEditorPage from './pages/admin/AdminPageEditorPage';
import AdminVisualEditorPage from './pages/admin/AdminVisualEditorPage';
import AdminThemePage from './pages/admin/AdminThemePage';
import AdminLegalEditor from './pages/admin/AdminLegalEditor';
import AdminFlashPage from './pages/admin/AdminFlashPage';
import AdminCommunityUsersPage from './pages/admin/AdminCommunityUsersPage';
import AdminMediaPage from './pages/admin/AdminMediaPage';
import AdminInvitationsPage from './pages/admin/AdminInvitationsPage';
import AdminSupportPage from './pages/admin/AdminSupportPage';
import ForumPage from './pages/ForumPage';
import ForumCategoryPage from './pages/ForumCategoryPage';
import ForumThreadPage from './pages/ForumThreadPage';
import ForumModerationLogPage from './pages/ForumModerationLogPage';
import AvisoDetailPage from './pages/AvisoDetailPage';
import ForumNewThreadPage from './pages/ForumNewThreadPage';
import NewsPreviewPage from './pages/NewsPreviewPage';
import EventPreviewPage from './pages/EventPreviewPage';
import ProtectedRoute, { AdminGuard } from './components/ProtectedRoute';
import SiteThemeProvider from './components/SiteThemeProvider';

export default function App() {
  return (
    <AuthProvider>
      <SiteThemeProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/es" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/cambiar-contrasena" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />
          <Route path="/change-password" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />
          <Route path="/recuperar-preguntas" element={<SecurityRecoverPage />} />
          <Route path="/security-recover" element={<SecurityRecoverPage />} />
          <Route path="/registro" element={<Navigate to="/login" replace />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/registro/confirmar" element={<RegisterConfirmPage />} />
          <Route path="/register/confirm" element={<RegisterConfirmPage />} />
          <Route path="/soporte/:token" element={<SupportThreadPage />} />
          <Route path="/support/:token" element={<SupportThreadPage />} />

          <Route path="/admin" element={<ProtectedRoute role={['admin', 'council', 'asistente']}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="menus" element={<AdminGuard perm="pages"><AdminMenusPage /></AdminGuard>} />
            <Route path="menus-legacy" element={<AdminGuard perm="pages"><MenuVisibilityPage /></AdminGuard>} />
            <Route path="interpreters" element={<AdminGuard perm="interpreters"><AdminInterpretersPage /></AdminGuard>} />
            <Route path="registrations" element={<AdminGuard perm="registrations"><AdminMemberRegistrationsPage /></AdminGuard>} />
            <Route path="news" element={<AdminGuard perm="news"><AdminNewsPage /></AdminGuard>} />
            <Route path="events" element={<AdminGuard perm="events"><AdminEventsPage /></AdminGuard>} />
            <Route path="foro" element={<AdminGuard perm="content"><AdminForumPage /></AdminGuard>} />
            <Route path="periodicals" element={<AdminGuard perm="periodicals"><AdminPeriodicalsPage /></AdminGuard>} />
            <Route path="translations" element={<AdminGuard perm="translations"><AdminTranslationsPage /></AdminGuard>} />
            <Route path="dues" element={<AdminGuard perm="dues"><AdminDuesPage /></AdminGuard>} />
            <Route path="profile-edits" element={<AdminGuard perm="profile_edits"><AdminProfileEditsPage /></AdminGuard>} />
            <Route path="contact" element={<AdminGuard perm="contact"><AdminContactPage /></AdminGuard>} />
            <Route path="contact/editor" element={<AdminGuard perm="contact"><AdminContactEditorPage /></AdminGuard>} />
            <Route path="board" element={<AdminGuard perm="board"><AdminBoardPage /></AdminGuard>} />
            <Route path="past-presidents" element={<AdminGuard perm="board"><AdminPastPresidentsPage /></AdminGuard>} />
            <Route path="photo-galleries" element={<AdminGuard perm="galleries"><AdminPhotoGalleriesPage /></AdminGuard>} />
            <Route path="home-layout" element={<AdminGuard perm="pages"><AdminHomeLayoutPage /></AdminGuard>} />
            <Route path="pages" element={<AdminGuard perm="pages"><AdminPagesPage /></AdminGuard>} />
            <Route path="pages/:page_key" element={<AdminGuard perm="pages"><AdminPageEditorPage /></AdminGuard>} />
            <Route path="pages/:page_key/visual" element={<AdminGuard perm="pages"><AdminVisualEditorPage /></AdminGuard>} />
            <Route path="theme" element={<AdminGuard perm="pages"><AdminThemePage /></AdminGuard>} />
            <Route path="settings" element={<AdminGuard perm="settings"><AdminSettingsPage /></AdminGuard>} />
            <Route path="newsletter" element={<AdminGuard perm="newsletter"><AdminNewsletterPage /></AdminGuard>} />
            <Route path="users" element={<AdminGuard perm="admin"><AdminUsersPage /></AdminGuard>} />
            <Route path="roles" element={<AdminGuard perm="admin"><AdminRolesPage /></AdminGuard>} />
            <Route path="papelera" element={<AdminGuard perm="content"><AdminTrashPage /></AdminGuard>} />
            <Route path="interpreters/bulk" element={<AdminGuard perm="interpreters"><AdminInterpretersBulkPage /></AdminGuard>} />
            <Route path="catalogos" element={<AdminGuard perm="interpreters"><AdminCatalogsPage /></AdminGuard>} />
            <Route path="catalogs" element={<AdminGuard perm="interpreters"><AdminCatalogsPage /></AdminGuard>} />
            <Route path="legal/:docKey" element={<AdminGuard perm="legal"><AdminLegalEditor /></AdminGuard>} />
            <Route path="flash" element={<AdminGuard perm="news"><AdminFlashPage /></AdminGuard>} />
            <Route path="community-users" element={<AdminGuard perm="interpreters"><AdminCommunityUsersPage /></AdminGuard>} />
            <Route path="invitations" element={<AdminGuard perm="interpreters"><AdminInvitationsPage /></AdminGuard>} />
            <Route path="media" element={<AdminGuard perm="media"><AdminMediaPage /></AdminGuard>} />
            <Route path="support" element={<AdminGuard perm="admin"><AdminSupportPage /></AdminGuard>} />
          </Route>

          {/* Public invitation page — interpreter clicks email link → sets username/password */}
          <Route path="/invitacion/:token" element={<InvitationAcceptPage />} />

          <Route path="/:lang" element={<Layout />}>
            <Route index element={<HomePage />} />

            {/* Spanish slugs */}
            <Route path="quienes-somos" element={<AboutPage />} />
            <Route path="directorio" element={<DirectoryPage />} />
            <Route path="directorio/:slug" element={<InterpreterProfilePage />} />
            <Route path="contacto" element={<ContactPage />} />
            <Route path="membresia" element={<MembershipPage />} />
            <Route path="noticias" element={<NewsPage />} />
            <Route path="noticias/preview/:token" element={<NewsPreviewPage />} />
            <Route path="noticias/:id" element={<NewsDetailPage />} />
            <Route path="eventos" element={<EventsPage />} />
            <Route path="eventos/preview/:token" element={<EventPreviewPage />} />
            <Route path="recursos" element={<ResourcesPage />} />
            <Route path="publicaciones" element={<PeriodicalsPage />} />
            <Route path="flash" element={<FlashPage />} />
            <Route path="consejo-directivo" element={<ConsejoDirectivoPage />} />
            <Route path="expresidentes" element={<ExpresidentesPage />} />
            <Route path="fotos-ex-presidentes" element={<FotosExpresidentesPage />} />
            <Route path="galeria" element={<GalleryPage />} />
            <Route path="estatutos" element={<StatutesPage />} />
            <Route path="aviso-de-privacidad" element={<PrivacyPage />} />
            <Route path="reglamentos/:slug" element={<RegulationPage />} />
            <Route path="mi-perfil" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><InterpreterDashboard /></ProtectedRoute>} />
            <Route path="mi-perfil/seguridad" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ProfileSecurityPage /></ProtectedRoute>} />
            <Route path="foro" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumPage /></ProtectedRoute>} />
            <Route path="interno" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumPage /></ProtectedRoute>} />
            <Route path="foro/c/:slug" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumCategoryPage /></ProtectedRoute>} />
            <Route path="foro/c/:slug/nuevo" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumNewThreadPage /></ProtectedRoute>} />
            <Route path="foro/t/:id" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumThreadPage /></ProtectedRoute>} />
            <Route path="foro/moderacion" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumModerationLogPage /></ProtectedRoute>} />
            <Route path="foro/aviso/:id" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><AvisoDetailPage /></ProtectedRoute>} />

            {/* English slugs */}
            <Route path="about-us" element={<AboutPage />} />
            <Route path="directory" element={<DirectoryPage />} />
            <Route path="directory/:slug" element={<InterpreterProfilePage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="membership" element={<MembershipPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="news/:id" element={<NewsDetailPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="periodicals" element={<PeriodicalsPage />} />
            <Route path="board-of-directors" element={<ConsejoDirectivoPage />} />
            <Route path="past-presidents" element={<ExpresidentesPage />} />
            <Route path="past-presidents-photos" element={<FotosExpresidentesPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="statutes" element={<StatutesPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="regulations/:slug" element={<RegulationPage />} />
            <Route path="my-profile" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><InterpreterDashboard /></ProtectedRoute>} />
            <Route path="my-profile/security" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ProfileSecurityPage /></ProtectedRoute>} />
            <Route path="forum" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumPage /></ProtectedRoute>} />
            <Route path="internal" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumPage /></ProtectedRoute>} />
            <Route path="forum/c/:slug" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumCategoryPage /></ProtectedRoute>} />
            <Route path="forum/c/:slug/nuevo" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumNewThreadPage /></ProtectedRoute>} />
            <Route path="forum/t/:id" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><ForumThreadPage /></ProtectedRoute>} />
            <Route path="forum/moderation" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']} forum><ForumModerationLogPage /></ProtectedRoute>} />
            <Route path="forum/aviso/:id" element={<ProtectedRoute role={['interpreter', 'admin', 'council', 'asistente']}><AvisoDetailPage /></ProtectedRoute>} />

            {/* CMS custom pages (admin-created) */}
            <Route path="p/:slug" element={<CustomPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/es" replace />} />
        </Routes>
      </BrowserRouter>
      </SiteThemeProvider>
    </AuthProvider>
  );
}
